import { client } from "../../../api/client";

const getPayloadForProcessingLogic = (logic, formInputs, userInputs, basketItems = [], moduleRevisionId = 0, moduleName = "unknown") => {
  if (moduleRevisionId === 0) {
    console.error("moduleRevisionId is required to execute logic");
    return {logEntries: [], quoteItems: []};
  }

    let convertedBasketItems = basketItems.map(x => ({...x, 
      customAttributes: JSON.stringify(x.customAttributes, null, 2),
      typeCustomAttributes: JSON.stringify(x.typeCustomAttributes, null, 2),

      // undefined values will be removed when serialised to JSON
      itemLookupType: undefined,
      quoteRevision: undefined,
      deleteDate: undefined,
      createdAt: undefined,   
      updatedAt: undefined,   
      createdBy: undefined,
      quoteCustomisationJson: undefined,
      quoteItems: undefined,
      statsByYear: undefined,
    }))


  return {
      logic: logic,
      userInputs: !userInputs ? [] : userInputs.map(x => ({
        inputGuid: x.inputGuid,
        value: (x.value ?? "").toString()
      })),
      formInputs: !formInputs ? [] : formInputs,
      basketItems: !basketItems ? [] : convertedBasketItems,
      moduleRevisionId: moduleRevisionId,
      moduleName: moduleName
    };
};

export const testLogic = async ({logic, formInputs, userInputs, basketItems = [], moduleRevisionId = 0}) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    if (logic?.flows?.length > 0 && logic.flows[0].guid === '56b4d42b-1f28-477e-ae1e-afa6e15b3d38') {
      return require("./_local/_quotegenerationauraoutputs.json")
    } else if (logic?.flows?.length > 0 && logic.flows[0].guid === '226a3f3c-680e-4132-9335-dd5b5c8d872a') {
      return require("./_local/_quotegenerationaurainputs.json")
    } else {
      return require("./_local/_quoteGenerationData.json")
    }

  } else {
    if (moduleRevisionId === 0) {
      console.error("moduleRevisionId is required to execute logic");
      return {logEntries: [], quoteItems: []};
    }

    try {

      const payLoad = getPayloadForProcessingLogic(logic, formInputs, userInputs, basketItems, moduleRevisionId);

      const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/QuoteGeneration/TestLogic",  payLoad);
      return response.data;
    } catch (error) {
        console.error("Error executing logic:", error);
        return [];
    }
  }
};


export const executeLogic = async ({logic, formInputs, userInputs, basketItems = [], moduleRevisionId = 0, moduleName = "unknown"}) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    if (logic?.flows?.length > 0 && logic.flows[0].guid === '56b4d42b-1f28-477e-ae1e-afa6e15b3d38') {
      return require("./_local/_quotegenerationauraoutputs.json")
    } else if (logic?.flows?.length > 0 && logic.flows[0].guid === '226a3f3c-680e-4132-9335-dd5b5c8d872a') {
      return require("./_local/_quotegenerationaurainputs.json")
    } else {
      return require("./_local/_quoteGenerationData.json")
    }

  } else {
    if (moduleRevisionId === 0) {
      console.error("moduleRevisionId is required to execute logic");
      return {logEntries: [], quoteItems: []};
    }

    try {

      const payLoad = getPayloadForProcessingLogic(logic, formInputs, userInputs, basketItems, moduleRevisionId, moduleName);

      const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/QuoteGeneration/ExecuteLogic",  payLoad);
      return response.data;
    } catch (error) {
        console.error("Error executing logic:", error);
        return [];
    }
  }
};
